import React from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import { AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

const IzbCoffeeAndCars = ({question,answer}) => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_1.png";
const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings.png";

const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowLeft}
      className={className}
      style={{
        ...style,
        display: "block",
        width: "50px",
        height: "50px",
        left: "-58px",
        zIndex:"99"
      }}
      onClick={onClick}
    />
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowRight}
      className={className}
 
      onClick={onClick}
    />
  );
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}; 
  
  return (
    <>
      <Breadcrumb2
        Heading="Latest News"
        img={BackgroundBrundcrumb}
        show={true}
      
      />

        <section>
            <div className="container pt-5">
              <h1 className="pb-5 text-left">Coffee & Cars with Indo Zambia Bank, in partnership with Southern Cross Motors</h1>
    
              <p className="pb-3">This past weekend we partnered with Southern Cross Motors for an unforgettable Coffee & Cars experience! Guests had the unique opportunity to test drive some of the world’s finest motor vehicle brands, including Mercedes-Benz GLB, Alfa Romeo, Jeep, Mitsubishi, GWM, and the fully electric ORA. It was more than just horsepower and style, attendees also got an exclusive look into Indo Zambia Bank’s Vehicle Finance solutions, making the journey from test drive to ownership even smoother.</p>

              <p className="pb-3">Start your Car-soft life with our Indo Vehicle Finance today! call <a href="tel:0211226294">0211 226294</a> or email <a href="mailto:credit@izb.co.zm">credit@izb.co.zm</a></p>


              <h2 className="pt-4 pb-4">Gallery</h2>
            
              <div className="test news-slider-list-slider row align-items-center pb-4">
                <Slider {...settings}>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-1.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-2.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-3.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-4.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-5.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-6.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-7.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-8.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-9.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-10.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-11.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-12.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-13.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-14.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-15.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-16.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-17.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-18.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-19.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-20.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-21.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-22.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-23.jpg" alt="Coffee & Cars with Indo Zambia Bank" />
                  </div>
                </Slider>
              </div>
            </div>

            

        </section>

      <CustomerCare />
      <OurStores />

    </>
  );
};

export default IzbCoffeeAndCars;